import React, { useEffect } from 'react';
import BottomSheetContainer from '../Bottomsheet/Bottomsheet';
import { hideErrorSheet } from '../../store/slices/errorSlice';
import { useAppDispatch , useAppSelector } from '../../store/hooks';
import Button from '../Button/Button';
import Typography from '../typography/Typography';
import {useDarkMode} from '@app/utils';
import { themeColorSet, ThemedText, ThemedView } from '@app/theme';
import {WarningCircle,Info } from '@app/sharedComponents/Icons/Icons';



const ErrorBottomSheet = () => {
  const errorSheetDetail = useAppSelector(state => state.errorSheet);
  const isDarkMode = useDarkMode()
  
  const dispatch = useAppDispatch();
  const { isErrorSheetVisible, errorType, errorMessage, closeOnBackdropPress , routeName ,errorHeading,isWarning=false, showErrorHeading=true, btnName='Edit details',showMsgBg=false} =
    errorSheetDetail;



  useEffect(() => {
    return () => {
      if (isErrorSheetVisible) {
        dispatch(hideErrorSheet());
      }
    };
    
  }, [isErrorSheetVisible]);

  const closeBottomSheet = () => {
    dispatch(hideErrorSheet());
  };
  return (
    <BottomSheetContainer
      isVisible={isErrorSheetVisible}
      close={closeBottomSheet}
      closeOnBackdropPress={closeOnBackdropPress ?? true}
      borderTopRightRadius={10}
      borderTopLeftRadius={10}
      containerStyle={themeColorSet['bg-fill-primary']}>
      <ThemedView alignItems='center' justifyContent='center' p="lg">
        <ThemedView my="sm" mb="2xl">
          {isWarning?
        <Info size={60} weight='fill' color={themeColorSet['icon-secondary']} />:
        <WarningCircle size={48} weight='fill' color={themeColorSet['icon-error']} />
          }
        </ThemedView>
        {showErrorHeading && <ThemedText variant='h5s' color='text-primary'>{errorHeading || "Verification failed!"}</ThemedText>}
        <ThemedView mt="sm" mb="2xl" backgroundColor={showMsgBg ? 'bg-fill-info':'bg-fill-primary'} p="sm" borderRadius='sm' width={'100%'}>
            <ThemedText textAlign='center' color='text-secondary' variant='b3r'>
            {errorMessage}
            </ThemedText>
        </ThemedView>
        <Button
          eventName={routeName + '_EDIT'}
          label={Boolean(btnName)?btnName:'Edit details'}
          type={'SOLID'}
          handlePress={closeBottomSheet}
        />
      </ThemedView>
    </BottomSheetContainer>
  );
};

export default ErrorBottomSheet;
